import { render, staticRenderFns } from "./Setbank.vue?vue&type=template&id=40c3a44a&scoped=true&"
import script from "./Setbank.vue?vue&type=script&lang=js&"
export * from "./Setbank.vue?vue&type=script&lang=js&"
import style0 from "./Setbank.vue?vue&type=style&index=0&id=40c3a44a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c3a44a",
  null
  
)

export default component.exports